import { Tag, Typography } from "antd"
import React, { useMemo } from "react"
import { ORANGE_SHIVVERS, PRIMARY_BLUE_SHIVVERS } from "src/app/theme";

interface CustomTagProps{
    label: string;
    color?: 'blue' | 'orange' | 'red';
}
const CustomTag : React.FC<CustomTagProps> = ({ label, color='blue' }) => {

    const bgColor = useMemo ( () => {
        switch(color){
            case 'blue':
                return PRIMARY_BLUE_SHIVVERS;
            case 'orange':
                return ORANGE_SHIVVERS;
            case 'red':
                return 'red-inverse';
            default:
                return PRIMARY_BLUE_SHIVVERS;
        }
    }, [color]);
    
    return (
        <Tag color={bgColor}>
            <Typography.Text style={{ color: 'white', fontSize:'12px', paddingInline: 4 }}>{label}</Typography.Text>
        </Tag>
    )
}

export default CustomTag;